import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {map, Observable} from "rxjs";



@Injectable({
  providedIn: 'root'
})
export class LocationService {
  baseURL = environment.baseUrl + 'location';

  constructor(private http: HttpClient) {
  }

  getAllLocations(eventId:any): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/get/event/${eventId}`)
  }

  saveLocation(eventId:any,locationName:string){
    const params = new HttpParams()
      .set('locationName', locationName);
    return this.http.post<any>(`${this.baseURL}/save/event/${eventId}`,{}, {params}).pipe(
      map((res: any) => {
        return res;
      })
    );
  }


}
